import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { DiagnosticsService } from './diagnostics.service';

@Injectable()
export class DiagnosticsErrorHandler extends ErrorHandler {
    constructor(private diagnostics: DiagnosticsService) {
        super();
    }

    handleError(error: any): void {
        // Unhandled promise rejections arrive wrapped; HTTP errors are already recorded by the interceptor.
        const cause = error?.rejection ?? error;
        if (!(cause instanceof HttpErrorResponse)) {
            this.diagnostics.recordJsError(cause);
        }
        super.handleError(error);
    }
}

export const DIAGNOSTICS_ERROR_HANDLER_PROVIDER = {
    provide: ErrorHandler,
    useClass: DiagnosticsErrorHandler,
};
